import { render } from "./PropertyListUser.vue?vue&type=template&id=258a6851"
import script from "./PropertyListUser.vue?vue&type=script&lang=js"
export * from "./PropertyListUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__